module.exports = __webpack_public_path__ + "static/media/W75F4071-WEB5.8f4338f2.svg";